import React, { FC, Fragment } from 'react'
import { DatePicker, PopupDatePicker } from '@components/DatePicker'
import { MobileOnly, DesktopOnly  } from '@components/MediaQuery'
import { Props } from './Question'

export const DatePickerFactory: FC<Props> = (props) => {
  const {
    error,
    id,
    onAnswerQuestion,
    value,
  } = props
  const {
    key,
    placeholder,
    datePickerFrom,
    datePickerTo,
    datePickerDaysAhead,
    datePickerDisabledDays,
  } = props.inputData

  const today = new Date();
  let dateToDaysAhead;

  if(datePickerDaysAhead){

  }

  const getDateFrom = () => {
    if(datePickerDaysAhead){
      return today;
    }
    if(datePickerFrom){
      return new Date(datePickerFrom);
    }
    return undefined;
  }

  const getDateTo = () => {
    if(datePickerDaysAhead){
      dateToDaysAhead = new Date();
      dateToDaysAhead.setDate(dateToDaysAhead.getDate() + datePickerDaysAhead);
      return dateToDaysAhead;
    }
    if(datePickerTo){
      return new Date(datePickerTo);
    }
    return undefined;
  }

  const handleChange = (selectedDate?: Date) => {
    onAnswerQuestion(key, selectedDate ? selectedDate.toString() : '')
  }

  return (
    <Fragment>
      <DesktopOnly>
        <DatePicker
          id={id}
          date={value ? new Date(value) : undefined}
          onChange={handleChange}
          hasError={error}
          placeholder={placeholder}
          dateFrom={getDateFrom()}
          dateTo={getDateTo()}
          disabledDays={datePickerDisabledDays && { daysOfWeek: datePickerDisabledDays }}
        />
      </DesktopOnly>
      <MobileOnly>
        <PopupDatePicker
          id={id}
          date={value ? new Date(value) : undefined}
          onChange={handleChange}
          hasError={error}
          placeholder={placeholder}
          dateFrom={getDateFrom()}
          dateTo={getDateTo()}
          disabledDays={datePickerDisabledDays && { daysOfWeek: datePickerDisabledDays }}
      />
      </MobileOnly>
    </Fragment>
  )
}
